
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 20.007 19.98\" id=\"icon-arrow-left\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M0,9.991c0,5.517,4.479,9.989,10.004,9.989c5.524,0,10.003-4.473,10.003-9.989\r\n\tC20.007,4.474,15.528,0,10.004,0C4.479,0,0,4.474,0,9.991z M2.987,9.995C2.988,9.867,3.023,9.8,3.134,9.688l6.47-6.47\r\n\tc0.151-0.152,0.403-0.156,0.547-0.007l1.187,1.187c0.153,0.153,0.143,0.396,0,0.551L7.49,8.784l9.135-0.001\r\n\tc0.217,0.001,0.395,0.18,0.396,0.392l-0.001,1.643c0.001,0.205-0.177,0.388-0.396,0.387l-9.134,0.002l3.851,3.834\r\n\tc0.14,0.157,0.15,0.391-0.004,0.551l-1.183,1.178c-0.148,0.149-0.4,0.147-0.55-0.002l-6.473-6.463\r\n\tC3.024,10.19,2.987,10.115,2.987,9.995z\"/> </symbol>";
module.exports = sprite.add(image, "icon-arrow-left");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/arrow-left.svg
 ** module id = 141
 ** module chunks = 24
 **/